import { render, staticRenderFns } from "./GaleriaCampanas.vue?vue&type=template&id=bd5e511a"
import script from "./GaleriaCampanas.vue?vue&type=script&lang=js"
export * from "./GaleriaCampanas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports